/***********************/
/* Angular + external */
import { Component, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
/***********************/
/* BFX */
// models
// components
// services
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxDialogOrderQuickFillWarningComponent } from "./bfx-dialog-order-quick-fill-warning.component";
import { BfxOrderDialogsProcessorService } from "./services/bfx-order-dialogs-processor.service";
//

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-dialog-order-quick-fill-warning",
  templateUrl: "./html/bfx-dialog-order-quick-fill-warning.html",
  standalone: false,
})
export class BfxDialogOrderDetailFillWarningComponent extends BfxDialogOrderQuickFillWarningComponent {
  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    _configService: BfxConfigService,
    _translationService: TranslateService,
    _orderDialogProcessorService: BfxOrderDialogsProcessorService,
    _element: ElementRef,
  ) {
    super(_configService, _translationService, _orderDialogProcessorService, _element);
  }
}
